<template>
  <div class="screenView info-page-wrapper">

    <main class="mainView">
      <section class="intro-text">
        <h2>{{ $t('info.version.header') }}</h2>
        <p>{{ $t('info.version.intro') }}</p>

        <h2>{{ $t('info.version.beta') }}</h2>
        <p>{{ $t('info.version.betaIntro') }}</p>

        <ul>
            <li>{{ $t('info.version.beta1') }}</li>
            <li>{{ $t('info.version.beta2') }}</li>
            <li>{{ $t('info.version.beta3') }}</li>
            <li>{{ $t('info.version.beta4') }}</li>
            <li>{{ $t('info.version.beta5') }}</li>
            <li>{{ $t('info.version.beta6') }}</li>
            <li>{{ $t('info.version.beta7') }}</li>
        </ul>

        <h2>{{ $t('info.version.bastion') }}</h2>
        <p></p>
        <ul>
            <li>{{ $t('info.version.bastiont1') }}</li>
            <li>{{ $t('info.version.bastiont2') }}</li>
            <li>{{ $t('info.version.bastiont3') }}</li>
            <li>{{ $t('info.version.bastiont4') }}</li>
            <li>{{ $t('info.version.bastiont5') }}</li>
            <li>{{ $t('info.version.bastiont6') }}</li>
        </ul>

        <p>{{ $t('info.version.bastionFunctionalImprovements') }}</p>
        <ul>
            <li>{{ $t('info.version.bastionf1') }}</li>
            <li>{{ $t('info.version.bastionf2') }}</li>
            <li>{{ $t('info.version.bastionf3') }}</li>
            <li>{{ $t('info.version.bastionf4') }}</li>
            <li>{{ $t('info.version.bastionf5') }}</li>
            <li>{{ $t('info.version.bastionf6') }}</li>
        </ul>

        <p>{{ $t('info.version.improvements') }}</p>
        <ul>
          <li>{{ $t('info.version.improvement1') }}</li>
          <li>{{ $t('info.version.improvement2') }}</li>
        </ul>

        <h2>Fixes</h2>
        <p>Bastion 1.0.1</p>
        <ul>
          <li>Solved ancient colour switch bug</li>
          <li>Improved static results game order (but needs a better solution still)</li>
          <li>Spaces in usernames disallowed: improved the interface</li>
          <li>Various visual enhancements, mobile view</li>
          <li>Fixed bug in refresh token functionality</li>
        </ul>
      </section>

    </main>
  </div>
</template>

<script>
  
export default {
  name: 'Version',

}

</script>


<style scoped>
/* Algemene Layout */

p {
    text-align: left;
}

li {
    text-align: left;
}

.info-page-wrapper {
  background-color: #1F1F1F;
  color: #E5E5E5;
}

.mainView {
  flex-grow: 1;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

.accent-blue {
  color: #5681c2;
  font-size: 1.8em;
  margin-bottom: 15px;
}

/* Secties */
.intro-text {
  text-align: center;
  padding: 40px 0;
  max-width: 800px;
  margin: 0 auto;
}

</style>


